// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1zFyd","bigColWidth":"Table_bigColWidth__3Tgkf","biggerColWidth":"Table_biggerColWidth__3pxC5","row":"Table_row__2dbDl","col":"Table_col__GRYm4"};